/* tslint:disable */
/* eslint-disable */
/**
 * RLawyers API
 * API pour la plateforme Call a Lawyer
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@avoloi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AvocatDto } from '../models';
// @ts-ignore
import type { CalendrierResponseDto } from '../models';
// @ts-ignore
import type { ErrorDto } from '../models';
// @ts-ignore
import type { FaqItemDto } from '../models';
/**
 * AvocatsApi - axios parameter creator
 * @export
 */
export const AvocatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupère les informations détaillées d\'un avocat
         * @summary Détail d\'un avocat
         * @param {AvocatsControllerGetAvocatTypeIdentifiantEnum} typeIdentifiant Type d\&#39;identifiant unique de l\&#39;avocat
         * @param {string} identifiant Identifiant unique de l\&#39;avocat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        avocatsControllerGetAvocat: async (typeIdentifiant: AvocatsControllerGetAvocatTypeIdentifiantEnum, identifiant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeIdentifiant' is not null or undefined
            assertParamExists('avocatsControllerGetAvocat', 'typeIdentifiant', typeIdentifiant)
            // verify required parameter 'identifiant' is not null or undefined
            assertParamExists('avocatsControllerGetAvocat', 'identifiant', identifiant)
            const localVarPath = `/avocats/details/{typeIdentifiant}/{identifiant}`
                .replace(`{${"typeIdentifiant"}}`, encodeURIComponent(String(typeIdentifiant)))
                .replace(`{${"identifiant"}}`, encodeURIComponent(String(identifiant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupère les créneaux de disponibilité d\'un avocat pour la semaine
         * @summary Disponibilités d\'un avocat
         * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
         * @param {number} [decalageSemaine] Décalage en semaines (0 &#x3D; semaine courante, 1 &#x3D; semaine suivante)
         * @param {Array<number>} [idsDomain] id du domaine
         * @param {number} [page] Numéro de page pour la pagination
         * @param {number} [limit] Nombre d\&#39;éléments par page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        avocatsControllerGetAvocatCalendrier: async (uuidAvocat: string, decalageSemaine?: number, idsDomain?: Array<number>, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuidAvocat' is not null or undefined
            assertParamExists('avocatsControllerGetAvocatCalendrier', 'uuidAvocat', uuidAvocat)
            const localVarPath = `/avocats/{uuidAvocat}/calendrier`
                .replace(`{${"uuidAvocat"}}`, encodeURIComponent(String(uuidAvocat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (decalageSemaine !== undefined) {
                localVarQueryParameter['decalageSemaine'] = decalageSemaine;
            }

            if (idsDomain) {
                localVarQueryParameter['idsDomain'] = idsDomain;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupère les questions/réponses FAQ personnalisées d\'un avocat
         * @summary FAQ d\'un avocat
         * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        avocatsControllerGetAvocatFaq: async (uuidAvocat: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuidAvocat' is not null or undefined
            assertParamExists('avocatsControllerGetAvocatFaq', 'uuidAvocat', uuidAvocat)
            const localVarPath = `/avocats/{uuidAvocat}/faq`
                .replace(`{${"uuidAvocat"}}`, encodeURIComponent(String(uuidAvocat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AvocatsApi - functional programming interface
 * @export
 */
export const AvocatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AvocatsApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupère les informations détaillées d\'un avocat
         * @summary Détail d\'un avocat
         * @param {AvocatsControllerGetAvocatTypeIdentifiantEnum} typeIdentifiant Type d\&#39;identifiant unique de l\&#39;avocat
         * @param {string} identifiant Identifiant unique de l\&#39;avocat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async avocatsControllerGetAvocat(typeIdentifiant: AvocatsControllerGetAvocatTypeIdentifiantEnum, identifiant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvocatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.avocatsControllerGetAvocat(typeIdentifiant, identifiant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvocatsApi.avocatsControllerGetAvocat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupère les créneaux de disponibilité d\'un avocat pour la semaine
         * @summary Disponibilités d\'un avocat
         * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
         * @param {number} [decalageSemaine] Décalage en semaines (0 &#x3D; semaine courante, 1 &#x3D; semaine suivante)
         * @param {Array<number>} [idsDomain] id du domaine
         * @param {number} [page] Numéro de page pour la pagination
         * @param {number} [limit] Nombre d\&#39;éléments par page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async avocatsControllerGetAvocatCalendrier(uuidAvocat: string, decalageSemaine?: number, idsDomain?: Array<number>, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendrierResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.avocatsControllerGetAvocatCalendrier(uuidAvocat, decalageSemaine, idsDomain, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvocatsApi.avocatsControllerGetAvocatCalendrier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupère les questions/réponses FAQ personnalisées d\'un avocat
         * @summary FAQ d\'un avocat
         * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async avocatsControllerGetAvocatFaq(uuidAvocat: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FaqItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.avocatsControllerGetAvocatFaq(uuidAvocat, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvocatsApi.avocatsControllerGetAvocatFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AvocatsApi - factory interface
 * @export
 */
export const AvocatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AvocatsApiFp(configuration)
    return {
        /**
         * Récupère les informations détaillées d\'un avocat
         * @summary Détail d\'un avocat
         * @param {AvocatsControllerGetAvocatTypeIdentifiantEnum} typeIdentifiant Type d\&#39;identifiant unique de l\&#39;avocat
         * @param {string} identifiant Identifiant unique de l\&#39;avocat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        avocatsControllerGetAvocat(typeIdentifiant: AvocatsControllerGetAvocatTypeIdentifiantEnum, identifiant: string, options?: RawAxiosRequestConfig): AxiosPromise<AvocatDto> {
            return localVarFp.avocatsControllerGetAvocat(typeIdentifiant, identifiant, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupère les créneaux de disponibilité d\'un avocat pour la semaine
         * @summary Disponibilités d\'un avocat
         * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
         * @param {number} [decalageSemaine] Décalage en semaines (0 &#x3D; semaine courante, 1 &#x3D; semaine suivante)
         * @param {Array<number>} [idsDomain] id du domaine
         * @param {number} [page] Numéro de page pour la pagination
         * @param {number} [limit] Nombre d\&#39;éléments par page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        avocatsControllerGetAvocatCalendrier(uuidAvocat: string, decalageSemaine?: number, idsDomain?: Array<number>, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<CalendrierResponseDto> {
            return localVarFp.avocatsControllerGetAvocatCalendrier(uuidAvocat, decalageSemaine, idsDomain, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupère les questions/réponses FAQ personnalisées d\'un avocat
         * @summary FAQ d\'un avocat
         * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        avocatsControllerGetAvocatFaq(uuidAvocat: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FaqItemDto>> {
            return localVarFp.avocatsControllerGetAvocatFaq(uuidAvocat, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AvocatsApi - object-oriented interface
 * @export
 * @class AvocatsApi
 * @extends {BaseAPI}
 */
export class AvocatsApi extends BaseAPI {
    /**
     * Récupère les informations détaillées d\'un avocat
     * @summary Détail d\'un avocat
     * @param {AvocatsControllerGetAvocatTypeIdentifiantEnum} typeIdentifiant Type d\&#39;identifiant unique de l\&#39;avocat
     * @param {string} identifiant Identifiant unique de l\&#39;avocat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvocatsApi
     */
    public avocatsControllerGetAvocat(typeIdentifiant: AvocatsControllerGetAvocatTypeIdentifiantEnum, identifiant: string, options?: RawAxiosRequestConfig) {
        return AvocatsApiFp(this.configuration).avocatsControllerGetAvocat(typeIdentifiant, identifiant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupère les créneaux de disponibilité d\'un avocat pour la semaine
     * @summary Disponibilités d\'un avocat
     * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
     * @param {number} [decalageSemaine] Décalage en semaines (0 &#x3D; semaine courante, 1 &#x3D; semaine suivante)
     * @param {Array<number>} [idsDomain] id du domaine
     * @param {number} [page] Numéro de page pour la pagination
     * @param {number} [limit] Nombre d\&#39;éléments par page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvocatsApi
     */
    public avocatsControllerGetAvocatCalendrier(uuidAvocat: string, decalageSemaine?: number, idsDomain?: Array<number>, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return AvocatsApiFp(this.configuration).avocatsControllerGetAvocatCalendrier(uuidAvocat, decalageSemaine, idsDomain, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupère les questions/réponses FAQ personnalisées d\'un avocat
     * @summary FAQ d\'un avocat
     * @param {string} uuidAvocat Identifiant unique de l\&#39;avocat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvocatsApi
     */
    public avocatsControllerGetAvocatFaq(uuidAvocat: string, options?: RawAxiosRequestConfig) {
        return AvocatsApiFp(this.configuration).avocatsControllerGetAvocatFaq(uuidAvocat, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AvocatsControllerGetAvocatTypeIdentifiantEnum = {
    Uuid: 'uuid',
    Slug: 'slug'
} as const;
export type AvocatsControllerGetAvocatTypeIdentifiantEnum = typeof AvocatsControllerGetAvocatTypeIdentifiantEnum[keyof typeof AvocatsControllerGetAvocatTypeIdentifiantEnum];
